import Image from 'next/image';

import { Section } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';
import { useIsMobile } from '@/helpers/screenResolutionHelper';

const MissionSection = () => {
  const [isMobile] = useIsMobile();
  return (
    <>
      <Section>
        <div className='container mx-auto px-4'>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-stretch'>
            <div className='max-w-xl mx-auto md:mx-0 text-center md:text-left py-6'>
              <div className='text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight text-gray-900'>
                <span className='block'>
                  Our{' '}
                  <span className='bg-control bg-clip-text text-transparent'>
                    Mission
                  </span>
                </span>
                <span className='block mt-1 text-3xl sm:text-4xl md:text-5xl bg-control bg-clip-text text-transparent'>
                  &amp; Foundation
                </span>
              </div>

              <div className='mt-6 text-base sm:text-lg text-gray-600 leading-relaxed'>
                We were founded with a simple purpose:{' '}
                <span className='font-semibold bg-control bg-clip-text text-transparent'>
                  Inspire &amp; Enable
                </span>{' '}
                <span className='font-semibold bg-control bg-clip-text text-transparent'>
                  Everyone to Celebrate More.
                </span>{' '}
                Rooted in the UAE (founded in Abu Dhabi in 2021), we use
                sophisticated systems so clients can feel the pure joy of a
                perfectly executed event—free from the burden of its creation.
              </div>
            </div>

            <div className='flex items-center justify-center'>
              <div className='relative w-full max-w-lg rounded-2xl p-4 bg-gray shadow-lg h-48 md:h-full flex items-center'>
                <div className='relative bg-white rounded-xl w-full p-6 md:p-8 h-full flex items-center justify-center overflow-visible'>
                  <div className='text-xl sm:text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight text-center'>
                    <span className='block'>
                      <span className='bg-control bg-clip-text text-transparent'>
                        “Celebrate more.
                      </span>
                    </span>
                    <span className='block mt-1'>
                      <span className='bg-control bg-clip-text text-transparent'>
                        Stress less.”
                      </span>
                    </span>
                  </div>
                  <div className='absolute bottom-4 right-4 w-12 h-12 md:w-20 md:h-20 pointer-events-none'>
                    <Image
                      src={`${staticMediaStoreBaseURL}/about-hafla/mission-section/celebration.svg`}
                      alt='Celebration'
                      width={isMobile ? 48 : 80}
                      height={isMobile ? 48 : 80}
                      style={{
                        width: isMobile ? '48px' : '80px',
                        height: isMobile ? '48px' : '80px'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
      <div className='border-t border-pink-100 mt-8' />
    </>
  );
};

export default MissionSection;
